var map = {
  "./km.json": [
    "235799",
    "868644"
  ],
  "./ru.json": [
    "749359",
    "28988"
  ],
  "./bg.json": [
    "739891",
    "991181"
  ],
  "./el.json": [
    "869114",
    "429246"
  ],
  "./en-pt.json": [
    "548755",
    "461616"
  ],
  "./ja.json": [
    "958487",
    "32027"
  ],
  "./ar.json": [
    "211129",
    "205189"
  ],
  "./rw.json": [
    "789641",
    "837168"
  ],
  "./sr.json": [
    "132642",
    "649131"
  ],
  "./lol.json": [
    "193487",
    "233621"
  ],
  "./fr.json": [
    "923449",
    "961883"
  ],
  "./sv.json": [
    "812636",
    "896294"
  ],
  "./as.json": [
    "633888",
    "133597"
  ],
  "./gu.json": [
    "776031",
    "118579"
  ],
  "./kk.json": [
    "946366",
    "24405"
  ],
  "./nb.json": [
    "466361",
    "616304"
  ],
  "./ta.json": [
    "126661",
    "848314"
  ],
  "./ky.json": [
    "312606",
    "144254"
  ],
  "./pl.json": [
    "89428",
    "324670"
  ],
  "./ro.json": [
    "358676",
    "343792"
  ],
  "./ka.json": [
    "301140",
    "300689"
  ],
  "./hu.json": [
    "943975",
    "769213"
  ],
  "./uk.json": [
    "394327",
    "5919"
  ],
  "./or.json": [
    "361997",
    "820736"
  ],
  "./uz.json": [
    "845231",
    "904760"
  ],
  "./hy.json": [
    "550579",
    "372395"
  ],
  "./de.json": [
    "277439",
    "27363"
  ],
  "./pt-pt.json": [
    "889961",
    "804385"
  ],
  "./vi.json": [
    "148800",
    "396993"
  ],
  "./tr.json": [
    "976918",
    "116537"
  ],
  "./da.json": [
    "212763",
    "712565"
  ],
  "./kn.json": [
    "641598",
    "473876"
  ],
  "./mr.json": [
    "998121",
    "304623"
  ],
  "./id.json": [
    "971714",
    "281016"
  ],
  "./lt.json": [
    "157778",
    "767293"
  ],
  "./lv.json": [
    "385146",
    "887021"
  ],
  "./fv.json": [
    "509543",
    "608277"
  ],
  "./zh-hans.json": [
    "344750",
    "8213"
  ],
  "./es.json": [
    "501884",
    "656367"
  ],
  "./ko.json": [
    "90244",
    "149605"
  ],
  "./te.json": [
    "574685",
    "684942"
  ],
  "./bn.json": [
    "107944",
    "135451"
  ],
  "./cs.json": [
    "290315",
    "574776"
  ],
  "./boxes.json": [
    "171084",
    "985751"
  ],
  "./my.json": [
    "654143",
    "718380"
  ],
  "./mn.json": [
    "431034",
    "65900"
  ],
  "./nl.json": [
    "739356",
    "370758"
  ],
  "./az.json": [
    "786447",
    "278766"
  ],
  "./accents.json": [
    "165872",
    "690686"
  ],
  "./pa.json": [
    "471700",
    "152979"
  ],
  "./pt.json": [
    "293115",
    "819654"
  ],
  "./extra.json": [
    "565379",
    "778114"
  ],
  "./it.json": [
    "1482",
    "680898"
  ],
  "./hi.json": [
    "511360",
    "981107"
  ]
};
function webpackAsyncContext(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1]).then(function() {
    return __webpack_require__.t(id, 3 | 16);
  });
}

webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 869730;
module.exports = webpackAsyncContext;
